// Diálogo para gerar a folha S-26 do mês seguinte com saldos anteriores preenchidos.
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { CalendarPlus, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NextMonthS26Dialog({ open, onOpenChange, form, onCreated }) {
  const [title, setTitle] = useState('');
  const [creating, setCreating] = useState(false);

  const handleCreate = async () => {
    setCreating(true);
    try {
      const { data } = await axios.post(`${API}/audit-forms/${form.id}/next-month`, { title });
      toast.success(`Folha "${data.title}" criada com os saldos anteriores preenchidos!`);
      setTitle('');
      onOpenChange(false);
      onCreated?.(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao gerar a próxima folha');
    } finally {
      setCreating(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="next-month-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarPlus className="w-5 h-5 text-primary" /> Gerar folha do mês seguinte
          </DialogTitle>
          <DialogDescription>
            Cria uma nova folha S-26 a partir de <strong>{form?.title}</strong> usando os valores salvos.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
            <li>Saldos do mês anterior (Donativos, Conta bancária/Cofre e Outra) puxados dos totais do Resumo</li>
            <li>Cabeçalho copiado (congregação, cidade, estado e nome da conta "Outra")</li>
            <li>Mês e ano avançados automaticamente quando preenchidos</li>
          </ul>
          <div className="space-y-1.5">
            <Label htmlFor="next-month-title">Título da nova folha (opcional)</Label>
            <Input
              id="next-month-title"
              data-testid="next-month-title-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Automático (ex.: Janeiro 2026)"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="next-month-cancel-btn">
            Cancelar
          </Button>
          <Button onClick={handleCreate} disabled={creating} data-testid="next-month-create-btn">
            {creating ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CalendarPlus className="w-4 h-4 mr-2" />}
            Gerar folha
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
